module.exports = __webpack_public_path__ + "img/image1.482204f6.png";